{
  "homepage": {
    "lv": "/",
    "en": "/",
    "ru": "/"
  },
  "account": {
    "lv": "/konts/",
    "en": "/account/",
    "ru": "/naznachenie/"
  },
  "contacts": {
    "lv": "/uznemums/kontakti/",
    "en": "/company/contact/",
    "ru": "/kompanija/kontakty/"
  },
  "about": {
    "lv": "/uznemums/nostra/",
    "en": "/company/nostra/",
    "ru": "/kompanija/o-nas/"
  },
  "product-payment": {
    "lv": "/informacija-pircejam/norekinasanas-veidi/",
    "en": "/information/payment-methods/",
    "ru": "/informacija-pokupatelju/metody-oplaty/"
  },
  "product-delivery": {
    "lv": "/informacija-pircejam/piegades-nosacijumi/",
    "en": "/information/delivery/",
    "ru": "/informacija-pokupatelju/dostavka-tovara/"
  },
  "b2b": {
    "lv": "/uznemums/biznesam/",
    "en": "/company/for-business/",
    "ru": "/kompanija/biznesu/"
  },
  "returns": {
    "lv": "/informacija-pircejam/precu-atgriesana/",
    "en": "/information/returns/",
    "ru": "/informacija-pokupatelju/vozvrat-tovara/"
  },
  "rules": {
    "lv": "/informacija-pircejam/noteikumi/",
    "en": "/information/terms-and-conditions/",
    "ru": "/informacija-pokupatelju/pravila/"
  },
  "privacy": {
    "lv": "/informacija-pircejam/privatuma-politika/",
    "en": "/information/privacy/",
    "ru": "/informacija-pokupatelju/konfidencialnost/"
  },
  "oeko-tex": {
    "lv": "/uznemums/oeko-tex-sertifikats/",
    "en": "/company/oeko-tex-standard-100-certificate/",
    "ru": "/kompanija/oeko-tex-standard-100-sertifikat/"
  },
  "loyalty": {
    "lv": "/informacija-pircejam/lojalitates-programma/",
    "en": "/information/loyalty-program/",
    "ru": "/informacija-pokupatelju/programma-lojalnosti/"
  },
  "guestbook": {
    "lv": "/uznemums/viesu-gramata/",
    "en": "/company/guest-book/",
    "ru": "/kompanija/gostevaja-kniga/"
  },
  "friends": {
    "lv": "/uznemums/draugi/"
  },
  "info-exclusive-bedding": {
    "lv": "/informacija-exclusive-gultas-vela/"
  },
  "info-mako-satin-bedding": {
    "lv": "/informacija-mako-satina-gultas-vela/"
  },
  "info-satin-bedding": {
    "lv": "/informacija-satina-gultas-vela/"
  },
  "info-flannel-bedding": {
    "lv": "/informacija-flanela-gultas-vela/"
  },
  "info-crinkled-bedding": {
    "lv": "/informacija-burzita-gultas-vela/"
  },
  "info-linen-bedding": {
    "lv": "/informacija-audekla-gultas-vela/"
  },
  "info-mixed-fiber-bedding": {
    "lv": "/informacija-dazadskiedru-gultas-vela/"
  },
  "info-bamboo-towels": {
    "lv": "/informacija-bambusa-dvieli/"
  },
  "info-towels-550": {
    "lv": "/informacija-kokvilna-dvieli-550g/"
  },
  "info-towels-380": {
    "lv": "/informacija-380g-dvieli/"
  },
  "info-cashmere-blankets": {
    "lv": "/informacija-pledi-ar-kasmiru/"
  },
  "info-merino-wool-blankets": {
    "lv": "/informacija-merino-vilnas-pledi/"
  },
  "info-wool-blankets": {
    "lv": "/informacija-vilnas-pledi/"
  },
  "info-satin-sheets": {
    "lv": "/informacija-satina-palagi/"
  },
  "info-jersey-sheets": {
    "lv": "/informacija-trikotazas-palagi/"
  },
  "info-terry-sheets": {
    "lv": "/informacija-frote-palagi/"
  },
  "secret-discount-code": {
    "lv": "/slepenais-atlaides-kods-lv/"
  }
}
